var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quote_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.818 0s-4.226 5.55-4.625 9.618c.308.1.602.201.894.31a12.037 12.037 0 0 1-.905 23.491 11 11 0 0 1-2.332.247C3.39 33.666.003 26.57.003 21.578.003 9.263 13.715.934 18.819.003m7.109 21.575c0 4.99 3.388 12.088 11.847 12.088.783.002 1.565-.081 2.33-.247a12.037 12.037 0 0 0 .908-23.488q-.434-.163-.891-.31c.395-4.069 4.621-9.618 4.621-9.618-5.107.931-18.816 9.26-18.816 21.575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quote_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50v33.663H0z"
  })))));
};
export default SvgQuote;